import React from 'react';
import {MainView} from "./MainView";
import {AS2CommStatusContextProvider} from "./As2CommStatusContextProvider";

const AS2CommunicationStatus=()=>{

    return(
        <AS2CommStatusContextProvider>
                <MainView />
        </AS2CommStatusContextProvider>


    );
}

export default AS2CommunicationStatus;